import { useEffect } from 'react';

// Privacy Policy is canonical on the marketing site.
// Any direct visit to app.solem.ai/privacy hops to www.solem.ai/privacy.
export function Privacy() {
  useEffect(() => {
    window.location.replace('https://www.solem.ai/privacy');
  }, []);
  return null;
}
